import { type ComponentProps, useRef } from 'react';

import { cn } from '@change/ds-utils';

import { useActionBar } from './hooks/useActionBar';

export const ActionBarSunrise: React.FC<ActionBarProps> = ({ children, className, ...rest }) => {
	const actionBarRef = useRef<HTMLDivElement>(null);
	const { data } = useActionBar(actionBarRef);
	return (
		<div
			data-qa="action-bar"
			ref={actionBarRef}
			data-testid={data.isSticky ? 'action-bar-sticky' : 'action-bar'}
			className={cn(
				'border-stroke-weaker bg-fill-inverse-strong right-0 -bottom-px left-0 z-10 mt-6 flex',
				data.isSticky ? 'fixed border-t md:sticky' : 'fixed border-none md:relative',
				className,
			)}
			{...rest}
		>
			<div className="container max-w-2xl p-4 md:p-0">{children}</div>
		</div>
	);
};

type ActionBarProps = ComponentProps<'div'>;
